<p-dialog [header]="'stripePaymentPlan.compareSubscriptionPlans' | transloco" [showHeader]="false" [(visible)]="isStripePaymentPlansDialogVisible"
  [style]="{'width': '900px'}" [modal]="true" (onHide)="closeStripePaymentDialog()">
  <div class="">
    <div class="row">
      <!-- For Artist Users -->
      @if (isArtist && activeSubscriptionRule) {
        <div class="col-4 border border-1 px-0 d-flex flex-column justify-content-between "
          >
          <div>
            <div class="subscription-button d-flex flex-column align-items-center text-white py-1">
              <span class="fs-5">{{ 'stripePaymentPlan.artflowFree' | transloco }}</span>
              <span>{{ 'stripePaymentPlan.freeForever' | transloco }}</span>
            </div>
            <div class="fw-bold text-center font-prizing-size" style="color: var(--secondary-color);">{{ 'stripePaymentPlan.free' | transloco }}</div>
            <ul class="mt-2 features-padding">
              <li class="mb-1">{{ 'stripePaymentPlan.artworksCreated' | transloco: { count: activeSubscriptionRule.NumberOfArtistProducts } }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.connectedGalleries' | transloco: { count: activeSubscriptionRule.NumberOfConnectionsAllowedToArtists } }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.artworkTypes' | transloco: { count: activeSubscriptionRule.NumberOfArtTypeSelection } }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.portfoliosAllowed' | transloco: { count: activeSubscriptionRule.NumberOfArtistPortfolios } }}</li>
              <li class="mb-1 text-dark text-opacity-50">
                {{ 'stripePaymentPlan.aiHelpDescriptions' | transloco: { count: activeSubscriptionRule.NumberOfArtistAIDescriptionCalls } }}
              </li>
              <li class="mb-1 text-dark text-opacity-50">{{ 'stripePaymentPlan.linksToInstagramFacebook' | transloco }}</li>
              <li class="mb-1 text-dark text-opacity-50">{{ 'stripePaymentPlan.advancedInsights' | transloco }}</li>
              <li class="mb-1 text-dark text-opacity-50">{{ 'stripePaymentPlan.accessGalleryMessenger' | transloco }}</li>
              <li class="mb-1 text-dark text-opacity-50">{{ 'stripePaymentPlan.allowGalleriesViewWorks' | transloco }}
              </li>
            </ul>
          </div>
          <div class="text-center subscription-bottom ">
            @if (isFreePlanUser ) {
              <div class="text-dark rounded-2 py-2 mb-2">{{ 'stripePaymentPlan.currentPlan' | transloco }}</div>
            }
          </div>
        </div>
      }

      <!-- For Gallery Users -->
      @if (isGallery && activeSubscriptionRule) {
        <div class="col-4 border border-1 px-0 d-flex flex-column justify-content-between "
          >
          <div>
            <div class="subscription-button d-flex flex-column align-items-center text-white py-1">
              <span class="fs-5">{{ 'stripePaymentPlan.artflowForGalleries' | transloco }}</span>
              <span>{{ 'stripePaymentPlan.freeForever' | transloco }}</span>
            </div>
            <div class="fw-bold text-center font-prizing-size" style="color: var(--secondary-color);">{{ 'stripePaymentPlan.free' | transloco }}</div>
            <ul class="mt-2 features-padding">
              <li class="mb-1">{{ 'stripePaymentPlan.artworksCreated' | transloco: { count: activeSubscriptionRule.NumberOfGalleryProducts } }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.connectedArtists' | transloco: { count: activeSubscriptionRule.NumberOfConnectionsAllowedToGallery } }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.consignmentProductsAccepted' | transloco: { count: activeSubscriptionRule.NumberOfConsignmentProductAccepted } }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.portfoliosAllowed' | transloco: { count: activeSubscriptionRule.NumberOfGalleryPortfolios } }}</li>
              <li class="mb-1 text-dark text-opacity-50">
                {{ 'stripePaymentPlan.aiHelpDescriptions' | transloco: { count: activeSubscriptionRule.NumberOfGalleryAIDescriptionCalls } }}
              </li>
              <li class="mb-1 text-dark text-opacity-50">{{ 'stripePaymentPlan.linksToInstagramFacebook' | transloco }}</li>
              <li class="mb-1 text-dark text-opacity-50">{{ 'stripePaymentPlan.advancedInsights' | transloco }}</li>
              <li class="mb-1 text-dark text-opacity-50">{{ 'stripePaymentPlan.accessGalleryMessenger' | transloco }}</li>
              <li class="mb-1 text-dark text-opacity-50">{{ 'stripePaymentPlan.allowGalleriesBrowseWorks' | transloco }}</li>
            </ul>
          </div>
          <div class="text-center subscription-bottom ">
            @if (isFreePlanUser ) {
              <div class="text-dark rounded-2 py-2 mb-2">{{ 'stripePaymentPlan.currentPlan' | transloco }}</div>
            }
          </div>
        </div>
      }

      <!-- Upgrade Plan Details -->
      @for (plan of stripeAllPlans; track plan) {
        <div class="col-4 border border-1 px-0 ">
          <div class="subscription-button d-flex flex-column align-items-center text-white py-1">
            <span class="fs-5">{{ isArtist ? 'ArtFlow for Artists' : 'ArtFlow for Galleries' }}</span>
            <span>
              {{ plan.IntervalCount === 1 ? 'Flexible ' + plan.Interval + ' Subscription' : 'Save with a ' +
              plan.IntervalCount + '-' + plan.Interval + ' Subscription' }}
            </span>
          </div>
          <div class="fw-bold text-center" style="color: var(--secondary-color);">
            <span>$</span>
            <span class="font-prizing-size">{{ plan.Amount }}</span>
            <span>/ {{ plan.Interval }}</span>
          </div>
          @if (isArtist) {
            <ul class="mt-2 ms-2 features-padding">
              <li class="mb-1">{{ 'stripePaymentPlan.unlimitedArtworks' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.unlimitedConnectedGalleries' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.multipleArtworkTypes' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.aiHelpToWriteDescriptions' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.linksToInstagramFacebook' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.advancedInsights' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.accessGalleryMessenger' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.allowGalleriesViewWorks' | transloco }}</li>
            </ul>
          }
          @if (isGallery) {
            <ul class="mt-2 ms-2 features-padding">
              <li class="mb-1">{{ 'stripePaymentPlan.unlimitedArtworks' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.unlimitedConnectedArtists' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.aiHelpToWriteDescriptions' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.linksToInstagramFacebook' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.advancedInsights' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.accessGalleryMessenger' | transloco }}</li>
              <li class="mb-1">{{ 'stripePaymentPlan.allowGalleriesBrowseWorks' | transloco }}</li>
            </ul>
          }
          <div class="text-center  subscription-bottom mt-5">
            @if (isFreePlanUser || isOnFreeTrial) {
              <button pButton class="subscription-button text-white rounded-2 py-2 mt-5 mb-2" (click)="upgradeAccount(plan)"
              >{{ 'stripePaymentPlan.subscribeNow' | transloco }}</button>
            }
            @if (!isFreePlanUser && !isOnFreeTrial) {
              <div class="text-primary">{{ 'stripePaymentPlan.currentPlan' | transloco }}</div>
            }
          </div>
        </div>
      }
    </div>

    <div class="d-flex justify-content-center mt-2">
      <button pButton type="button" class="p-button-secondary p-button-outlined"
      [label]="'stripePaymentPlan.notReadyYetClose' | transloco" (click)="closeStripePaymentDialog()"></button>
    </div>
  </div>
</p-dialog>